const useContractDocumentStyles = {
  page: {
    paddingBottom: 20,
    paddingLeft: 40,
    paddingRight: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff"
  },
  center: {
    textAlign: "center"
  },
  title: {
    fontSize: "10pt",
    marginBottom: "10pt",
    fontFamily: "Helvetica-Bold",
    textAlign: "center"
  },
  body: {
    fontSize: "10pt",
    lineHeight: 1.5
  },
  bodyn: {
    fontSize: "10pt",
    textAlign: "left"
  },
  redText: {
    color: "red"
  },
  boldText: {
    fontFamily: "Helvetica-Bold"
  },
  lineBreak: {
    height: "10pt"
  },
  imageSection: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "50pt"
  },
  image: {
    width: "100pt",
    height: "100pt"
  }
};

export default useContractDocumentStyles;
